var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
  callback: _vm.handleScroll,
  once: true
  }),expression:"{\n  callback: handleScroll,\n  once: true\n  }"}],class:{fadeIn: _vm.isVisible}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }